<template>
    <div>
        <div class="header" :style="{'z-index':hzindex}">
            <div class="header-tips" v-if="deadlineShow">
                <em class="txt1">
                    <template v-if="$i18n.locale === 'en'">
                        Your system usage period will expire on {{year}}-{{month}}-{{day}} please contact customer service staff to renew in time.
                    </template>
                    <template v-else>
                        您的系统使用期限将于{{year}}年{{month}}月{{day}}日到期，请及时联系客服人员进行续期，联系电话0315-3206632。
                    </template>
                </em>
                <em class="txt2">
                    <template v-if="$i18n.locale === 'en'">
                        Your system usage period will expire on {{year}}-{{month}}-{{day}} please contact customer service staff to renew in time.
                    </template>
                    <template v-else>
                        您的系统使用期限将于{{year}}年{{month}}月{{day}}日到期，请及时联系客服人员进行续期，联系电话0315-3206632。
                    </template>
                </em>
            </div>
            <div class="logo">
                <img v-if="haslogo" :src="logoImg" alt="logo">
                <span>{{headerTitle}}</span>
            </div>
            <div class="hovbtn" @mouseenter="featureshow" @mouseleave="featurehide">
                <span class="fnBtn">{{ $t("header.nav") }}</span>
                <i class="el-icon-arrow-down"></i>
            </div>
            <div class="fr" ref="frbox">
                <ul class="iconbox">
                    
                </ul>
                <div class="hovbtn" @mouseover="userSettingshow" @mouseout="userSettinghide">
                    <i class="iconfont icon-user"></i>
                    <span class="fnBtn">{{ headerWho }}</span>
                    <i class="el-icon-arrow-down"></i>

                    <div v-show="userHshow" class="userhover" @mouseenter="userSettingshow" @mouseleave="userSettinghide">
                        <ul>
                            <li @click="personalFlag=true">{{ $t("header.uimenu.userInfo") }}</li>
                            <li>
                                <el-tooltip effect="dark" :content="sysVersion"  placement="right" :enterable="false">
                                    <div>{{ $t("header.uimenu.version") }}</div>
                                </el-tooltip>
                            </li>
                            <li @click="openChange">{{ $t("header.uimenu.typetheme") }}</li>
                            <li @click="exit">{{ $t("header.uimenu.loggingstatus") }}</li>
                        </ul>
                        <div class="triangle-top"></div>
                    </div>
                </div>
                <div class="ywkehu" v-if="isYw || isCustomer">
                    <span class="fnBtn">{{consumerName}}</span>
                    <i v-if="isYw" class="el-icon-refresh" @click="openDevops"></i>
                </div>
            </div>
        </div>
        <el-dialog 
            class="headerdia"
            :title="$t('header.uimenu.skintitle')"
            :visible.sync="openChangedia"
            width="40%">
            <ul class="themelist">
                <li @click="changeTheme('theme1')">
                    <div class="imgbox">
                        <img src="@/assets/image/home/theme1.png" alt="theme1">
                    </div>
                    <div class="label" style="text-align:center;">{{ $t("header.theme1") }}</div>
                    <img v-show="themeCheckShow === 'theme1'" class="isyou" src="@/assets/image/home/themechecked.png" alt="checked">
                </li>
                <li @click="changeTheme('theme2')">
                    <div class="imgbox">
                        <img src="@/assets/image/home/theme3.png" alt="theme2">
                    </div>
                    <div class="label" style="text-align:center;">{{ $t("header.theme2") }}</div>
                    <img v-show="themeCheckShow === 'theme2'" class="isyou" src="@/assets/image/home/themechecked.png" alt="checked">
                </li>
            </ul>
        </el-dialog>
        <Featurelist :isShow="featureProp"/>
        <devops />
        <personal :openPersonal.sync="personalFlag"></personal>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import {remove_session_cache , get_session_cache} from "@/config/cache/cache.js"
import across from "@/config/components/across.js"
import Featurelist from './Featurelist'
import Devops from '@/components/custom/Devops'
import Personal from '@/components/custom/Personal'
import { $http } from '@/config/api/axios'

import logo from '@/assets/image/icons/ico_huizhong.png'

export default {
    name:'Header',
    components:{
        Featurelist,
        Devops,
        Personal,
    },
    data(){
        return{
            haslogo:true,
            logoImg:logo,
            headerTitle:localStorage.getItem('language-type') === "zh-CN" ? '汇中表务管理系统' : 'Smart Water',
            featureProp:false,
            hzindex: 8100,
            userHshow:false,
            openChangedia:false,
            themeCheckShow:'theme1',
            customerId:'',
            consumerName:'',
            isYw:false,
            isCustomer:false,
            isAdmin:false,
            headerWho:'',
            devopsFlag:false,
            personalFlag:false,
            deadlineShow:false,
            year:'',
            month:'',
            day:'',
            alarmNum:0,
            openAlarmflag:false,
            // audioSwitch: localStorage.getItem('voice') === 'close' ? false : true,
        }
    },
    watch:{
        audioSwitch(val){
            // if(val){
            //     document.querySelector('#music').play()
            // }else{
            //     document.querySelector('#music').pause()
            // }
        }
    },
    methods:{
        ...mapMutations('Home', [
            'SET_GLOBAL_THEME',
        ]),
        featureshow(){
            this.featureProp = true
        },
        featurehide(){
            this.featureProp = false
        },
        userSettingshow(){
            this.userHshow = true;
        },
        userSettinghide(){
            this.userHshow = false;
        },
        openChange(){
            this.openChangedia = true;
        },
        changeTheme(theme){
            if(this.themeCheckShow === theme) return
            this.themeCheckShow = theme;
            let currentRouterName = this.$route.path;
            this.$router.push({path:"controller"});
            setTimeout(()=>{
                this.$router.push({path:currentRouterName});
            },0);
            localStorage.setItem('echartsTheme', theme); //本地存储echarts主题，生命周期与窗口生命周期一致，有其他需求再进行调整。
            this.SET_GLOBAL_THEME(theme)
            document.getElementsByTagName('body')[0].className = theme+' '+this.$root.$lang;
        },
        openDevops(){
            across.$emit('openFromHeader',true)
        },
        exit(){ // 退出登录
            remove_session_cache('Access-Token');
            this.$router.push('/login')
        },
        getDeadline(){
            $http('get','customer/getExpireDate')
            .then(res=>{
                if(res.status === "SUCCESS"){
                    if(!!res.data){
                        let date = res.data.split('-');
                        this.year = date[0];
                        this.month = date[1];
                        this.day = date[2];
                        this.deadlineShow = true;
                    }else{
                        this.deadlineShow = false;
                    }
                }
            }).catch(err=>{
            })
        },
        openAlarm(e){
            this.openAlarmflag = !this.openAlarmflag;
        },
        setAlarmNum(num){
            this.alarmNum = num;
        },
        controlAudio(bool){
            this.audioSwitch = bool;
            let status = bool ? 'open' : 'close';
            localStorage.setItem('voice',status);
        }
    },
    mounted(){
        if(!localStorage.getItem('echartsTheme')) {
            localStorage.setItem('echartsTheme', 'theme1'); //默认存储皮肤一的echarts主题。
            document.getElementsByTagName('body')[0].className = 'theme1 '+ this.$root.$lang;
        }else{
            this.themeCheckShow = localStorage.getItem('echartsTheme');
            document.getElementsByTagName('body')[0].className = this.themeCheckShow +' '+this.$root.$lang;
        }
        const loginType = get_session_cache('loginType');
        const consumer = localStorage.getItem(`consumer_${get_session_cache('loginId')}`)
        this.headerWho = get_session_cache('loginName')
        this.isYw = loginType == '1008002' ? true : false
        this.isAdmin = loginType == '1008001' ? false : true
        this.consumerName = !!consumer ? JSON.parse(consumer).userName : ''
        this.customerId = !!consumer ? JSON.parse(consumer).userId : ''
        //this.getDeadline() // 获取截止日期 表务不需要获取逾期日期
        if(loginType != '1008002' && loginType != '1008001'){
            this.isCustomer = true;
            if(!!JSON.parse(localStorage.getItem('tokenUser'))){
                this.customerId = JSON.parse(localStorage.getItem('tokenUser')).tokenUserCustomerId;
            }
        }
        if(localStorage.getItem('language-type') === "zh-CN"){
            document.getElementsByTagName('title')[0].textContent = '汇中表务管理系统';
        }else{
            document.getElementsByTagName('title')[0].textContent = 'Smart Water';
        }
        if(!!this.customerId){
            $http('get','customerInfo/getCustomerSystemInfo',{customerId:this.customerId}).then(res=>{
                if(res.status === "SUCCESS"){
                    localStorage.setItem('systemName','');
                    if(!!res.data.logoUrl){ // logo存在
                        this.logoImg = this.imgHost + res.data.logoUrl;
                    }else if(!!res.data.systemName){ // logo不存在系统名称存在
                        this.haslogo = false;
                    }
                    if(!!res.data.systemName){ // 系统名称存在
                        this.headerTitle = res.data.systemName;
                        document.getElementsByTagName('title')[0].textContent = res.data.systemName;
                        localStorage.setItem('systemName',res.data.systemName)
                    }else if(!!res.data.logoUrl){ // 系统名称不存在logo存在
                        this.headerTitle = '';
                    }
                    this.consumerName = res.data.customerName;
                }
            })
        }
    }
}
</script>

<style lang='less' scoped>
.header{
    position: relative;
    height: 46px;
    padding: 0 10px;
    display: flex;
    line-height: 46px;
    color:#fff;
    margin-bottom: 10px;
    .logo{
        display: flex;
        font-size: 18px;
        margin-right: 45px;
        img{
            width: auto;
            height: 30px;
            margin-top: 7px;
            margin-right: 10px;
        }
    }
    .hovbtn{
        position: relative;
        cursor: pointer;
        span{
            margin-right: 4px;
        }
        i{
            vertical-align: -2px;
        }
        i.iconfont{
            margin-right: 4px;
            font-size: 17px;
        }
        .spec{
            vertical-align: baseline;
            font-size: 16px;
            margin-right: 4px;
        }
    }
    .fnBtn{
            font-size: 14px;
        }
    .fr{
        position: relative;
        margin-left: auto;
        display: flex;
    }
    .userhover{
        position: absolute;
        min-width: 110px;
        right: -10px;
        top: 40px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0px 0px 5px rgba(68, 48, 96, 0.2);
        padding: 0px 15px;
        padding-top: 5px;
        li{
            color: #7b7d87;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            &:last-child{
                border-top: 1px solid #bbbcc4;
                margin-top: 5px;
                line-height: 38px;
            }
            &:hover{
                color: #4980d7;
            }
        }
    }
    .iconbox{
        display: flex;
        margin-top: 1px;
        li{
            position: relative;
            margin-right: 20px;
            i{
                font-size: 17px;
                cursor: pointer;
            }
            span{
                display: inline-block;
                position: absolute;
                top: 3px;
                left: 5px;
                background: #f54743;
                color: #fff;
                height: 14px;
                padding: 0px 5px;
                line-height: 14px;
                font-size: 12px;
                border-radius: 10px;
            }
        }
    }
    .ywkehu{
        border-left: 1px solid #bbbcc4;
        height: 30px;
        line-height: 30px;
        margin-top: 8px;
        margin-left: 10px;
        padding-left: 10px;
        span{
            margin-right: 5px;
        }
        i{
            cursor: pointer;
        }
    }
    .header-tips{
        position: absolute;
        left: 550px;
        top:0;
        height: 46px;
        width: 36%;
        line-height: 46px;
        background: inherit;
        overflow: hidden;
        em{
            position: absolute;
            color: #ea0407;
            white-space: nowrap;
        }
        .txt1{
            left: 0;
            animation: orientScroll1 20s linear 2s infinite;
        }
        .txt2{
            left: 140%;
            animation: orientScroll2 20s linear 2s infinite;
        }
    }
    .relative{
        position: relative;
    }
}
@keyframes orientScroll1{
    0% {left: 0;}
    100% {left: -800px;}
}
@keyframes orientScroll2{
    0% {left: 800px;}
    100% {left: 0;}
}
.headerdia{
    z-index: 4099 !important;
}
.themelist{
    display: flex;
    justify-content: space-around;
    height: 150px;
    li{
        width: 187px;
        height: 117px;
        border-radius: 5px;
        box-shadow: 0px 0px 5px rgba(68, 48, 96, 0.2);
        position: relative;
        cursor: pointer;
        .imgbox{
            width: 100%;
            height: 100%;
            &:hover{
                opacity: .7;
            }
        }
        .isyou{
            position: absolute;
            display: block;
            top: calc(50% - 20px);
            left: calc(50% - 20px);
            width: 40px;
        }
        .label{
            text-align: center;
            font-size: 16px;
            line-height: 50px;
        }
    }
}
.en-US{
    .header .userhover li:last-child{
        line-height: 3;
    }
    .header .header-tips{
        left: 620px;
    }
    .header .userhover{
        min-width: 116px;
    }
}
</style>